const data = [
    {
        question: 'What is an extended warranty??',
        answer: "An extended warranty, also known as a service contract, is a protection plan that covers the cost of certain repairs and services after your vehicle's original manufacturer's warranty expires. It helps you avoid paying out-of-pocket for unexpected repairs."
    },
    {
        question: 'What does the extended warranty cover?',
        answer: "Our extended warranty covers major vehicle components like the engine, transmission, electrical systems, and more. Specific coverage details can vary by plan, so be sure to review the terms of your selected plan."
    },
    {
        question: 'How do I get a quote?',
        answer: "You can get a personalized quote by entering your VIN or license plate number. If you don't have these details, you can also provide your vehicle's year, make, model, and mileage. Once you’ve entered your information, you’ll see the available warranty plans and pricing."
    },
    {
        question: 'Where can I use my extended warranty?',
        answer: "Our warranties are accepted at thousands of authorized service centers nationwide. Whether you're at home or on the road, you can find a nearby location to get the repairs covered by your plan."
    },
    {
        question: 'How does the payment process work?',
        answer: "We offer flexible payment options, including 0% interest financing. You can choose to pay upfront or in monthly installments, making it easier to fit your warranty into your budget."
    },
    {
        question: 'Can I transfer or cancel my warranty?',
        answer: 'Yes, our warranties are transferable if you sell your vehicle, adding value for the new owner. If you decide to cancel your warranty early, you may be eligible for a prorated refund based on the time remaining on your contract.'
    }
]
export default data